import NoSSR from 'react-no-ssr';

import {
  EnforceLogin,
  ThemeProvider,
  ToastContainer
} from '@spotahome/ui-library';

import LoginSignUpModal from '@spotahome/marketplace-common/src/components/login/LoginModal';

import './main.scss';

const ENFORCE_LOGIN_IMAGE =
  'https://static.spotahome.com/images/enforce_login.svg';

const EnforceLoginPage = () => {
  return (
    <ThemeProvider flags={{ newButtons: true }}>
      <ToastContainer />
      <NoSSR>
        <EnforceLogin customImageURL={ENFORCE_LOGIN_IMAGE} />
        <LoginSignUpModal />
      </NoSSR>
    </ThemeProvider>
  );
};
export default EnforceLoginPage;
